import { Client as MockClient } from '../client';

MockClient.prototype._get = function(path: string, options: any = {}): Promise<any> {
  // Move apiKey from params
  if (options.params?.apiKey) {
    options.apiKey = options.params.apiKey;
    delete options.params.apiKey;
  }

  return {
    method: 'get',
    url: path,
    ...options,
    ...(this as any).headers(options)
  };
};

MockClient.prototype._post = function(path: string, data: object, options: any = {}): Promise<any> {
  // Move apiKey from params
  if (options.params?.apiKey) {
    options.apiKey = options.params.apiKey;
    delete options.params.apiKey;
  }

  return {
    method: 'post',
    url: path,
    data,
    ...options,
    ...(this as any).headers(options)
  };
};

MockClient.prototype._put = function(path: string, data: object, options: any = {}): Promise<any> {
  // Move apiKey from params
  if (options.params?.apiKey) {
    options.apiKey = options.params.apiKey;
    delete options.params.apiKey;
  }

  return {
    method: 'put',
    url: path,
    data,
    ...options,
    ...(this as any).headers(options)
  };
};

MockClient.prototype._delete = function(path: string, options: any = {}): Promise<any> {
  // Move apiKey from params
  if (options.params?.apiKey) {
    options.apiKey = options.params.apiKey;
    delete options.params.apiKey;
  }

  return {
    method: 'delete',
    url: path,
    ...options,
    ...(this as any).headers(options)
  };
};

export const Client = MockClient;
